/**
 * @fileoverview > handler for the "/engagement/:app_group_id/canvas/:workflow_id/versions/:version_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdCanvasWorkflowIdVersionsVersionIdCacheKeys } from "./constants";
import type { PutEngagementAppGroupIdCanvasWorkflowIdVersionsVersionIdProps, CanvasVersionResult } from "./types";

export const putCanvasVersion = reactQueryMutationAdapter(
  engagementAppGroupIdCanvasWorkflowIdVersionsVersionIdCacheKeys,
  (props: PutEngagementAppGroupIdCanvasWorkflowIdVersionsVersionIdProps): Promise<CanvasVersionResult> => {
    return fetch(
      `/engagement/${props.appGroupId}/canvas/${props.canvasId}/versions/${props.versionId}`,
      "PUT",
      props,
      {},
      { propagateFetchRequestError: false }
    );
  }
);
